import React, { useState, useEffect } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import './Dashboard.css';
import Products from './Products';
import AddProduct from './Addproduct';
import RateList from './RateList';


const Dashboard = () => {
  const [activeTab, setActiveTab] = useState('products');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // Handle screen resize
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div className="dashboard-container">
      {/* Hamburger Menu (Only for Mobile) */}
      {isMobile && (
        <button className="menu-btn" onClick={() => setSidebarOpen(!sidebarOpen)}>
          {sidebarOpen ? <FaTimes /> : <FaBars />}
        </button>
      )}

      {/* Sidebar */}
      <div className={`sidebar ${sidebarOpen ? 'show' : ''}`}>
        <nav>
          <a href="#" className={activeTab === 'products' ? 'active' : ''}
            onClick={() => { setActiveTab('products'); setSidebarOpen(false); }}>Products</a>
          <a href="#" className={activeTab === 'addproducts' ? 'active' : ''}
            onClick={() => { setActiveTab('addproducts'); setSidebarOpen(false); }}>Add Product</a>
          <a href="#" className={activeTab === 'rate' ? 'active' : ''}
            onClick={() => { setActiveTab('rate'); setSidebarOpen(false); }}>Add Rates</a>
          
        </nav>
      </div>

      {/* Main Content */}
      <div className="main-content">
        {activeTab === 'products' && <Products />}
        {activeTab === 'addproducts' && <AddProduct />}
        {activeTab === 'rate' && <RateList />}
        
      </div>
    </div>
  );
};

export default Dashboard;
